define.alias("shared/components/shared/modal/section", "settings/components/shared/modal/section");